/**
 * Supabase JSON/JSONB alanları (positionen, variants, suppliers, vs.)
 * için güvenli parse / serialize yardımcıları.
 *
 * Sessiz fallback yerine, parse hatalarını şeffaf hale getirir:
 * - Array değilse ve string parse edilemezse `options.onError(...)` çağrılır.
 * - Hiçbir zaman exception fırlatmaz (UI render akışını bozmaz).
 */

/**
 * JSON array alanını güvenli parse eder.
 * @param {unknown} value - DB'den gelen alan (array | string | null)
 * @param {object} [options]
 * @param {string} [options.fieldName] - Hata mesajında görünecek alan adı
 * @param {(message: string) => void} [options.onError] - Parse hatası callback'i
 * @returns {Array<any>}
 */
export function parseArrayField(value, options = {}) {
  const { fieldName = 'field', onError } = options;
  if (Array.isArray(value)) return value;
  if (value == null || value === '') return [];
  if (typeof value === 'string') {
    try {
      const parsed = JSON.parse(value);
      if (Array.isArray(parsed)) return parsed;
      onError?.(`'${fieldName}' ist kein Array nach dem Parsen.`);
      return [];
    } catch (err) {
      onError?.(`'${fieldName}' konnte nicht gelesen werden: ${err.message}`);
      return [];
    }
  }
  onError?.(`'${fieldName}' hat einen unerwarteten Typ.`);
  return [];
}

/**
 * Array alanını DB'ye yazılabilir bir JSON string'e çevirir.
 * Supabase tarafı JSONB sütunda Array/Obj da kabul ediyor; ancak
 * karışık deploy'lardan kaynaklı string beklentisi için kullanılabilir.
 * @param {Array<any>} value
 * @returns {string}
 */
export function serializeArrayField(value) {
  const arr = Array.isArray(value) ? value : [];
  return JSON.stringify(arr);
}
